import { Link } from "react-router-dom";


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container container">
        <div className="footer-text">
          <h3>Responsible Gambling</h3>
          <p>
            Make thoughtful decisions regarding your choices. Play responsibly. If you need assistance,
            call Gambling Help at 1800 858 858 or visit GambleAware at responsiblegambling.vic.gov.au.
          </p>
          <p>
            BetStop, the National Self-Exclusion Register, is a complimentary service for individuals who wish
            to exclude themselves from all online betting platforms. Find out more at betstop.gov.au.
          </p>
          <p>
            Ozjackpotclaim operates under a license from the Victorian Government Department and is regulated by
            the Victorian Gambling and Casino Control Commission (VGCCC), reflecting our strong commitment
            to responsible gambling.
          </p>
          <p>
            This service is managed by The Lottery Corporation Limited (ABN 99 081 925 662). The Ozjackpotclaim
            Game logo is a trademark of The Lottery Corporation Limited. All rights reserved.
          </p>
          <p><strong>Gambling is prohibited for individuals under 18 years of age.</strong></p>
        </div>

        <div className="footer-logos">
          <img src="../images/18.svg" alt="18+" />
          <img src="../images/gamblerhelp.webp" alt="Gambler's Help" />
          <img src="../images/vsg.svg" alt="Victoria Government" />
          <img src="../images/reset.webp" alt="Reset" />
          <img src="../images/gambleaware.svg" alt="Gamble Aware" />
        </div>

        <div className="footer-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms-and-conditions">Terms and Conditions</Link>
          <Link to="/responsible-gambling">Responsible Gambling</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
